import { LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

import * as icons from '@gn-audio/icons';
import { Button, ButtonVariantType, JabraIcon } from '@gn-audio/jss-components';

import { useLinkAction } from 'utils/hooks/useLinkAction';

type NavButtonProps = {
  variant: ButtonVariantType;
  size: 'xs' | 's' | 'm' | 'l';
  link?: LinkField;
  icon?: string;
  title: string;
  ariaLabel?: string;
  onClick?: () => void;
};

export type { NavButtonProps };

const NavButton = ({
  variant,
  size,
  link,
  icon,
  title,
  ariaLabel,
  onClick,
  ...props
}: NavButtonProps) => {
  const { asLink, href, linkOnClick } = useLinkAction(link, onClick);

  const buttonProps = {
    variant: variant || 'primary',
    size: size || 'm',
    ...(asLink ? { asLink: true, href } : {}),
    ...(linkOnClick ? { onClick: linkOnClick } : {}),
    ...(icon
      ? {
          icon: <JabraIcon Icon={icons[icon as keyof typeof icons]} />,
          iconPlacement: 'right' as const,
        }
      : {}),
    ...(ariaLabel && {
      'aria-label': ariaLabel,
    }),
    ...props,
  };

  return <Button {...buttonProps}>{title}</Button>;
};

export default NavButton;
